import { useQuery } from '@tanstack/react-query';
import { getUser } from 'utils/user';
import { configCatProvider, getKey } from './useFeatureFlag';

const useAssessmentV2Enabled = (key, defaultValue = false, { city }, options) =>
  useQuery(
    getKey(key),
    () =>
      configCatProvider.isFeatureEnabled(key, defaultValue, {
        identifier: getUser().user_id.toString(),
        custom: { city },
      }),
    options,
  );

export default useAssessmentV2Enabled;
